module.exports = __webpack_public_path__ + "static/img/MO@3x.59b2c77d.jpg";